import React, {useState, useEffect} from 'react'


import TradeStates from '../states/TradeStates'
import AlgoStates from '../states/AlgoStates'
import TriggerStates from '../states/TriggerStates'

import useTriggerStore from "../../stores/TriggersStore"
import useTradeStore from "../../stores/TradesStore"
import  useAlgoStore  from '../../stores/AlgosStore'

function Orders() {
  const [selectedTab, setSelectedTab] = useState(process.env.REACT_APP_TRADE_FIRST ? "trade" : "algo")

    const algoCount = useAlgoStore((state) => state.algo_count)
    const tradeCount = useTradeStore((state) => state.trade_count)
    const triggerCount = useTriggerStore((state) => state.trigger_count)
  return (
    <div className='widget_body'>
      <ul className="widget_tab_nav">
          <li className={selectedTab === "algo" ? "active_widget_tab li no_drag": "li no_drag"} onClick={()=> setSelectedTab("algo")}><span>algos {algoCount !== 0 ? <div className='state_count no_drag'>{algoCount > 99 ? "99+" : algoCount}</div>: null}</span></li>
          <li className={selectedTab === "trade" ? "active_widget_tab li no_drag": "li no_drag"}  onClick={()=> setSelectedTab("trade")}><span>trades{tradeCount !== 0 ? <div className='state_count no_drag' >{tradeCount > 99 ? "99+" : tradeCount}</div> : null}</span></li>
          <li className={selectedTab === "trigger" ? "active_widget_tab li no_drag": "li no_drag"}  onClick={()=> setSelectedTab("trigger")}><span>triggers{triggerCount !== 0 ? <div className='state_count no_drag'>{triggerCount > 99 ? "99+" : triggerCount}</div>: null}</span></li>
      </ul>
      { renderTabContent(selectedTab)}
    </div>
  )
}

export default Orders;

function renderTabContent(selectedTab) {
  switch (selectedTab) {
      case 'trade':
          return <TradeStates />;
      case 'algo':
          return <AlgoStates />;
      case 'trigger':
          return <TriggerStates />;
      default:
          return null;
  }
}